<!-- 限销策略操作 -->
<template>
	<div>
		<subComponents  ref="showSelectData"></subComponents>
		<el-dialog :visible.sync="dataActionBox.showStatus" :title="dataActionBox.boxTitle"  append-to-body :close-on-click-modal="false" center  width="50%" top="2rem">
			<el-form size="mini" label-position="top" label-width="200px">
				<el-form-item label="限销策略分组">
					<el-input v-model.trim="sendDataInfo.sgvgName" @focus="$refs['showSelectData'].openBox('restrictionStrategyGroupList','restrictionStrategyGroupList','sgvgId')"></el-input>
				</el-form-item>
				<el-form-item label="商品">
					<el-input   v-model.trim="sendDataInfo.bgmName" clearable @focus="$refs['showSelectData'].openBox('businessGoodsList','bgmId','bgmId')"></el-input>
				</el-form-item>
				<el-form-item label="限销数量">
					<el-input   v-model="sendDataInfo.sgvgSnumber" type="number"></el-input>
				</el-form-item>
				<el-form-item label="限销开始时间">
					<el-date-picker v-model="sendDataInfo.sgvgStart"  type="date"  format="yyyy 年 MM 月 dd 日" value-format="timestamp"></el-date-picker>
				</el-form-item>
				<el-form-item label="限销结束时间">
					<el-date-picker v-model="sendDataInfo.sgvgEnd"  type="date"  format="yyyy 年 MM 月 dd 日" value-format="timestamp"></el-date-picker>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dataActionBox.showStatus = false">取消</el-button>
				<el-button type="primary" @click="sendDataAction" v-if="dataActionBox.actionType==0">保存</el-button>
				<el-button type="primary" @click="sendDataAction" v-if="dataActionBox.actionType==1">保存</el-button>
			</div>
		</el-dialog>
	</div>
	
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
	name:'restrictionStrategyAction',
	props:[],
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
			dataActionBox:{
				showStatus:false,
				boxTitle:'新增'||'编辑',
				actionType:0, // 0新增，1修改
			},
			sendDataInfo:{
				sgvgId: "",
				sgvgName: "",
				bgmName:"",
				sgvgGid:"",
				sgvgSnumber:"",
				sgvgEnd:"",
				sgvgStart:"",
			},
			
        };
    },
    //监听属性 类似于data概念
    computed: {
	},
    //监控data中的数据变化
    watch: {
	},
    //方法集合
    methods: {
		initActionBox(){
			for(let key in this.sendDataInfo){
				this.sendDataInfo[key]  = ''
			}
		},
		
		isShowData(name,value){
			switch(name){
				case 'restrictionStrategyGroupList':
					var dataInfo = sessionStorage.getItem('selectRestrictionStrategyGroupData')
					console.log(dataInfo)
					if(dataInfo){
						dataInfo = JSON.parse(dataInfo)
						this.sendDataInfo.sgvgId = dataInfo.sgvgId
						this.sendDataInfo.sgvgName = dataInfo.sgvgName
					}
				break;
				case 'bgmId':
					var dataInfo = sessionStorage.getItem('selectBusinessGoodsEntryInfo')
					if(dataInfo){
						dataInfo = JSON.parse(dataInfo)
						this.sendDataInfo.sgvgGid = dataInfo.bgmId
						this.sendDataInfo.bgmName = dataInfo.bgmName
					}
				break;
				default:
					this.sendDataInfo[name] = value
				
			}
		},
		
	
		
		openBox(cate,oldData=''){
			this.initActionBox()
			if(cate == 0){
				this.dataActionBox.boxTitle = '新增限销策略'
			}else{
				this.dataActionBox.boxTitle = '编辑限销策略'
				this.sendDataInfo  = oldData
			}
			this.dataActionBox.actionType = cate
			this.dataActionBox.showStatus = true
			
		},
		async sendDataAction(){
			if(this.sendDataInfo.sgvgId==''){
				this.$message({
					message: '请选择限销策略分组',
					type: 'error'
				});
				return false
			}
			if(this.sendDataInfo.sgvgGid==''){
				this.$message({
					message: '请选择商品',
					type: 'error'
				});
				return false
			}
		
			
			var newSendDataInfo = JSON.parse(JSON.stringify(this.sendDataInfo))
		
			if(this.dataActionBox.actionType==0){
				var responseData =  await this.$http.addRestrictionStrategy(newSendDataInfo)
			}else{
				var responseData =  await this.$http.setRestrictionStrategy(newSendDataInfo)
			}
			
			
			if(responseData.status == 200){
				this.dataActionBox.showStatus = false
				this.$message({
					message: '操作成功',
					type: 'success'
				});
				this.$parent.getDataList()
				
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
	
		
		
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() {
	}, //生命周期 - 创建之前
    beforeMount() {
	}, //生命周期 - 挂载之前
    beforeUpdate() {
	}, //生命周期 - 更新之前
    updated() {
	}, //生命周期 - 更新之后
    beforeDestroy() {
	}, //生命周期 - 销毁之前
    destroyed() {
	}, //生命周期 - 销毁完成
    activated() {
	}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>